module.exports = __webpack_public_path__ + "media/images/flags/km-439aefbd14d40572fd54232fd8437ea6.svg";